// src/components/Adviser/Tabs/LicenseCertificates/LicenseCertificatesTab.jsx

import React from "react";
import { useNavigate } from "react-router-dom";
import SecondaryButton from "../../../../DesignSystem/Buttons/SecondaryButton";
import LicenseCertificates from "../Pages/LicenseCertificates";
import {useCanEditLicenceTabs} from "../utils/accessPermissions";

export const LicenseCertificatesTab = ({
  details,
  loading,
  adviserEmail,
  canEdit = false,
}) => {
  const navigate = useNavigate();
  const canEditLicenceTabs = useCanEditLicenceTabs();

  const adviserKey =
    details?.adviserId || adviserEmail || details?.adviserDoc?.email || "";

  const handleEdit = () => {
    if (!adviserKey) return;

    navigate(
      `/advisers/${encodeURIComponent(adviserKey)}/license-certificates/edit`,
      {
        state: {
          adviserEmail,
          adviserKey,
          adviserId: details?.adviserId || "",
          details,
          returnTo: `/advisers/${encodeURIComponent(adviserKey)}?tab=licenceCertificates`,
        },
      },
    );
  };

  return (
    <div className="smFeed">
      {canEditLicenceTabs ? (
        <div className="smEditActions">
          <div>
            <div className="FP_Body_Semibold">
              Licence Certificates and CPD
            </div>
            <p className="Content-Small muted">
              DPL, SPS, Fit & Proper, Competent Adviser and T&C records.
            </p>
          </div>

          {/* <SecondaryButton
            label="Bulk Upload"
            onClick={() =>
              navigate(`/advisers/license-certificates/bulk-upload`)
            }
          /> */}
          {canEditLicenceTabs ? (
            <div className="smEditActionsRight">
              {/* <SecondaryButton label="Add CPD" onClick={handleAddCpd} /> */}
              <SecondaryButton label="Edit Details" onClick={handleEdit} />
            </div>
          ) : null}
        </div>
      ) : null}

      <LicenseCertificates details={details} loading={loading} />
    </div>
  );
};

export default LicenseCertificatesTab;
